import { ColorSchemeType } from "@/enums/ColorSchemeType";
import { MaterialCategory } from "@/enums/MaterialCategory";

export interface RoomImages {
  livingRoom?: string;
  kitchen?: string;
  bathroom?: string;
}

export interface IncludedMaterial {
  category: MaterialCategory;
  name: string;
  details: string;
  swatchImageUrl?: string;
}

export interface ColorSchemeInterface {
  _id: string;
  id: string;
  name: string;
  builderId: string;
  price: number;
  imagesUrls: string[];
  type: ColorSchemeType;
  description?: string;
  roomImages?: RoomImages;
  includedMaterials?: IncludedMaterial[];
}

export interface ExternalColorSchemeInterface extends ColorSchemeInterface {
  type: ColorSchemeType.EXTERNAL;
}

export interface InternalColorSchemeInterface extends ColorSchemeInterface {
  type: ColorSchemeType.INTERNAL;
}

export type CreateExternalColorSchemeInterface = Omit<
  ExternalColorSchemeInterface,
  "_id"
>;
export type UpdateExternalColorSchemeInterface =
  Partial<ExternalColorSchemeInterface>;

export type CreateInternalColorSchemeInterface = Omit<
  InternalColorSchemeInterface,
  "_id"
>;
export type UpdateInternalColorSchemeInterface =
  Partial<InternalColorSchemeInterface>;

export interface QueryExternalColorSchemeInterface
  extends QueryColorSchemeInterface {
  type: ColorSchemeType.EXTERNAL;
}

export interface QueryInternalColorSchemeInterface
  extends QueryColorSchemeInterface {
  type: ColorSchemeType.INTERNAL;
}

export type QueryColorSchemeInterface = Partial<ColorSchemeInterface>;

export const colorSchemeDefault: QueryColorSchemeInterface = {
  _id: "",
  builderId: "",
  name: "",
  price: undefined,
  imagesUrls: [],
  type: undefined,
};

export type CreateColorSchemeInterface = Omit<ColorSchemeInterface, "_id">;

export type UpdateColorSchemeInterface = Partial<ColorSchemeInterface>;

export type ColorSchemeInterfaceWithImagesUrls = ColorSchemeInterface & {
  imagesUrls: string[];
};

// ── Estate colour scheme types ────────────────────────────────────────────────────────────────────

export interface RoomImageItem {
  name: string;
  url?: string;
}

export interface EstateProductMaterial {
  name: string;
  description?: string;
  url?: string;
}

export interface EstateColorSchemeInterface {
  _id: string;
  name: string;
  estateId: string;
  description?: string;
  roomImagesList?: RoomImageItem[];
  productMaterials?: EstateProductMaterial[];
}

export type CreateEstateColorSchemeInterface = Omit<
  EstateColorSchemeInterface,
  "_id"
>;
export type UpdateEstateColorSchemeInterface = Partial<
  Omit<EstateColorSchemeInterface, "_id">
>;
